const mockRequestsBypassList = ['typekit.net', 'node_modules', 'localhost'];
export default mockRequestsBypassList;
